export default function extractInnerMessage(message: any): string {
    const errMessage = message?.response?.data?.message || String(message);

    const matchMessage = String(errMessage).match(/"message"\s*:\s*"([^"]*)"/);
    return matchMessage ? matchMessage[1] : errMessage;
}

// tenta extrair messagem de erro lançada pelo script, para mostrar mensagem mais amigavel para o usuario
export function extractApiScriptErrorMessage(message: any): string {
    const regex = /^Unable to evaluate script while executing activity '[^']+' in the process definition with id '[^']+':Error:\s*(.*?)\s*in <eval>/;

    const errMessage = message?.response?.data?.message || String(message);
  
    const matchMessage = String(errMessage).match(regex);
    return matchMessage ? matchMessage[1] : errMessage;
}